import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxDataGridModule,
  DxFileUploaderModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopoverModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToastModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { CommentService } from 'src/app/services/comment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { TechnicalComponentsService } from 'src/app/services/tech-components.service';
import { ProjectInfoService } from 'src/app/services/project-info.service';
import { LoggingService } from 'src/app/services/logging.service';
import { GlobalPopupService } from 'src/app/components/generic-popup/presets/global-popup/global-popup.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { CommentsComponent } from 'src/app/components/comments/comments.component';
import { environment } from 'src/environments/environment';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { HostListener } from '@angular/core';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { GpdPaginationComponent } from 'src/app/components/gpd-pagination/gpd-pagination.component';
import {
  ComponentDetailsPanelComponent,
  ComponentDetail,
  DocLink,
  SiteInfo,
  ProjectInfo,
} from 'src/app/components/component-details-panel/component-details-panel.component';
import { AppConfig } from 'src/app/app.config';
import { GenericPopupComponent, PopupButton } from 'src/app/components/generic-popup/generic-popup.component';
import { ProjectStatus } from '../../../../../../interfaces/entities/project';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { ApiFileService } from 'src/app/services/api-file.service';

@Component({
    selector: 'app-project-info-components',
    templateUrl: './project-info-components.component.html',
    styleUrls: ['./project-info-components.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxTextAreaModule,
        DxButtonModule,
        CommentsComponent,
        DxFormModule,
        DxDataGridModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxFileUploaderModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxToastModule,
        DxValidatorModule,
        DeletePopupComponent,
        FileViewerComponent,
        GpdButtonComponent,
        GpdPaginationComponent,
        ComponentDetailsPanelComponent,
        GenericPopupComponent,
    ]
})
export class ProjectComponentsComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly apiFileService = inject(ApiFileService);

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  deletePopupVisible: boolean = false;

  searchTerm: string = AppGlobals.searchPanelText;
  addComponentSearchTerm: string = '';

  @ViewChild('dataGridSearch', { static: false }) dataGridSearch: DxDataGridComponent;
  @ViewChild('componentGrid', { static: false }) componentGrid: DxDataGridComponent;
  @ViewChild('addComponentGrid', { static: false }) addComponentGrid: DxDataGridComponent;

  minPopupHeight: any = '600px';

  contentLoadedVisible: boolean = true;
  selectedRow: any = null;
  popUpTitle: any = '';

  editTitle: any = $localize`:@@editProjectComponent:Edit Project Component`;

  editComponentVisible: boolean = false;

  editNotesVisible: boolean = false;

  allowDeletingVisible: boolean = false;
  showQuantityInput: boolean = false;
  addNewComponentVisible: boolean = false;

  uploadDocumentVisible: boolean = false;

  addComponentVisible: boolean = false;

  popupVisible: boolean = false;

  amountVisible: boolean = false;

  projectComponentList: any = [];

  componentList: any = [];

  companyList: any = [];

  selectedComponentQuantity: any = '';

  editMode: any = false;

  deleteMessage = $localize`:@@deleteComponent:Are you sure you want to delete this component?`;

  confirmText = $localize`:@@confirmCaps:CONFIRM`;
  cancelText = $localize`:@@cancelCaps:CANCEL`;

  selectedComponent: any = {};

  componentTypes: any = [];

  projectId: any = '';
  gridConnectionId: any = '';
  newestComponentId: any = null;
  projectNotes: any = '';

  selectedComponentIdForDocUpload: any = '';
  selectedComponentToAdd: any = {};
  selectedComponentType: any = null;

  newId = 0;

  addComponentGridSelection: any;
  addComponentGridPageSize: number = 10;

  projectDatasheets: any[] = [];

  dynamicPageSize: number = 10;
  availableHeight: number = 400;

  // Details Panel Properties
  detailsPanelVisible: boolean = false;
  detailsPanelHeight: number = 500;
  componentDetails: ComponentDetail[] = [];
  doclinks: DocLink[] = [];
  componentId: number | null = null;
  documentList: any[] = [];
  sitesForPanel: SiteInfo[] = [];
  projectsForPanel: ProjectInfo[] = [];
  disableDownloadAll: boolean = true;
  downloadLinks: any[] = [];

  @ViewChild(FileViewerComponent) fileViewer: FileViewerComponent;

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.calculatePageSize();
    this.calculateDynamicPageSize();
  }

  projectStatus: string;

  constructor(
    private commentService: CommentService,
    private activatedRoute: ActivatedRoute,
    private technicalComponentsService: TechnicalComponentsService,
    private appGlobals: AppGlobals,
    private router: Router,
    private projectInfoService: ProjectInfoService,
    private loggingService: LoggingService,
    private globalPopupService: GlobalPopupService,
    private activityLog: ActivityLogService
  ) {}

  editPopupLeftButtons: PopupButton[] = [];
  editPopupButtons: PopupButton[] = [];

  get addPopupButtons(): PopupButton[] {
    return [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => this.closeAddComponent() },
      { text: $localize`:@@confirm:Confirm`, type: 'primary', icon: 'tick', disabled: !this.showQuantityInput, onClick: () => this.addSelectedComponent(null) },
    ];
  }

  ngOnInit() {
    this.editPopupLeftButtons = [
      { text: $localize`:@@delete:Delete`, type: 'danger', icon: 'delete', onClick: () => this.deleteComponent() },
    ];
    this.editPopupButtons = [
      { text: $localize`:@@cancel:Cancel`, type: 'secondary', icon: 'cancel', onClick: () => this.editComponentVisible = false },
      { text: $localize`:@@save:Save`, type: 'primary', icon: 'tick', onClick: () => this.saveComponent() },
    ];
    this.searchTerm = '';
    if (environment.isTestEnvironment === true) {
      this.appGlobals.SetGlobalMenuIndex(2);
    } else {
      this.appGlobals.SetGlobalMenuIndex(2);
    }
    this.projectId = parseInt(this.activatedRoute.snapshot.params.id);
    this.activityLog.logView({ Section: ActivitySection.PROJECT_COMPONENTS, ProjectId: this.projectId });
    this.projectInfoService.getGlobalProjectInfo({ ProjectId: this.projectId }).then(result => {
      if (!result.hasError) this.projectStatus = result.globalProjectInfoResultItem?.status;
    });
    let projectId = {
      ProjectId: this.projectId,
      FilterType: 'project',
    };

    //GET COMPANY LIST FOR MANUFACTURER DROP DOWN

    this.technicalComponentsService.getCompanies({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.companyList = result.companyList;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.technicalComponentsService.getTechComponents(projectId).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.componentList = result.components.sort((a, b) => {
            const modelA = a.model || '';
            const modelB = b.model || '';
            return modelA.localeCompare(modelB);
          });
          this.componentTypes = result.componentTypes;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.technicalComponentsService
      .getProjectTechComponents({ ProjectComponentRequestItems: [{ ProjectId: this.projectId }] })
      .then(
        result => {
          if (result.hasError === true) {
            this.showErrMsg = true;
            this.errMsg = result.feedback;
          } else {
            this.projectComponentList = result.components.sort((a, b) => a.model.localeCompare(b.model));
            this.projectNotes = result.globalNotes;
            this.projectDatasheets = result.projectDatasheets;
            this.componentTypeForFilter = this.componentTypes
              .filter(type => this.projectComponentList.some(comp => Number(comp.typeId) === Number(type.id)))
              .sort((a, b) => a.name.localeCompare(b.name));
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    this.getComponentDocsList();
    this.getAllDocLinks();
    this.calculatePageSize();
  }

  ngAfterViewInit(): void {
    this.calculateDynamicPageSize();
  }

  ngOnDestroy(): void {
    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
    }
  }

  private calculateDynamicPageSize(): void {
    const viewportHeight = window.innerHeight;
    const reservedSpace = 250;
    const toolbarHeight = 60;
    const headerHeight = 40;
    const rowHeight = 40;

    this.availableHeight = viewportHeight - reservedSpace - toolbarHeight - 80;
    this.detailsPanelHeight = this.availableHeight;

    const contentHeight = this.availableHeight - headerHeight;
    const calculatedPageSize = Math.floor(contentHeight / rowHeight);

    this.dynamicPageSize = Math.max(10, Math.min(calculatedPageSize, 1000));

    if (this.componentGrid?.instance) {
      this.componentGrid.instance.pageSize(this.dynamicPageSize);
      this.componentGrid.instance.refresh();
      this.getGridPageInfo();
    }
  }

  getNewId() {
    this.newId -= 1;
    return this.newId;
  }

  closePopup(): void {
    this.popupVisible = false;
    this.addNewComponentVisible = false;
    this.addComponentVisible = false;
    this.editComponentVisible = false;
    this.popupVisible = false;
    this.uploadDocumentVisible = false;
    this.amountVisible = false;
    this.minPopupHeight = '600px';
    this.showQuantityInput = false;
  }

  private get completedProjectWarning(): string {
    return $localize`:@@editCompletedProjectWarning:The project is complete. To make changes, set the status of the project to "Active".`;
  }

  private get pausedProjectWarning(): string {
    return this.projectStatus === ProjectStatus.INACTIVE
      ? $localize`:@@editInactiveProjectWarning:The project is inactive. To make changes, set the status of the project to "Active".`
      : $localize`:@@editCanceledProjectWarning:The project is canceled. To make changes, set the status of the project to "Active".`;
  }

  editComponent(e: any): void {
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      return;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    // this.popupVisible = true;
    this.popUpTitle = this.editTitle;
    this.editComponentVisible = true;
    this.detailsPanelVisible = false;
    this.selectedComponent = e.data;
  }

  addSelectedComponent(e): void {
    e?.preventDefault();
    this.addComponentGridSelection['id'] = this.getNewId();
    this.projectComponentList.push(this.addComponentGridSelection);
    this.selectedComponent = { ...this.addComponentGridSelection }; // Clone to avoid reference issues

    let componentToAdd = {
      ProjectId: this.projectId,
      ComponentId: this.selectedComponent.componentId,
      ComponentQuantity: this.selectedComponent.quantity,
    };

    if (this.selectedComponent.quantity <= 0) {
      AppGlobals.ShowErrorMessage($localize`:@@enterValidQuantity:Please enter a valid quantity greater than zero.`);
      return;
    }

    this.technicalComponentsService.addTechComponentToProject({ ProjectComponentRequestItems: [componentToAdd] }).then((result) => {
      if (result.hasError === true) {
        if (typeof result.feedback === 'string' && result.feedback.trim().endsWith('2')) {
          this.showErrMsg = true;
          this.errMsg = result.feedback.replace(/\s*2$/, '').trim();
          this.selectedComponentToAdd = this.selectedComponent;
          this.closePopup();
        } else {
          AppGlobals.ShowErrorMessage(result.feedback);
          this.reloadDataGrid().then(() => {
            this.closePopup();
            this.addComponentVisible = false;
          });
        }

      } else {
        this.addNewComponentVisible = false;
        this.showQuantityInput = false;
        this.popupVisible = false;
        let success = true;
        this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Component Saved` });
        this.addComponentVisible = false;
        this.addComponentGridSelection = null;
        // Reload data first, then show upload popup
        this.reloadDataGrid().then(() => {
          // Find the updated component with hasDataSheet info
          const updatedComponent = this.projectComponentList.find(
            c => c.componentId === this.selectedComponent.componentId
          );
          if (updatedComponent) {
            this.selectedComponent = updatedComponent;
          }
        });
      }
    }, (error: any) => {
      AppGlobals.ShowErrorMessage(error);
    });
  }

  addNewComponent(): void {
    this.minPopupHeight = '';
    this.popUpTitle = $localize`:@@addNewComponent:Add New Component`;
    this.popupVisible = true;
    this.addComponentVisible = false;
    this.addNewComponentVisible = true;
    this.showQuantityInput = false;
    this.selectedComponent = {
      manufacturer: null,
      manufacturerId: null,
      type: null,
      typeId: null,
      model: null,
      documents: null,
      notes: null,
      hasDataSheet: false,
    };
  }

  saveComponent(): void {

    // Validation: quantity must be greater than 0
    if (!this.selectedComponent || this.selectedComponent.quantity == null || this.selectedComponent.quantity <= 0) {
      AppGlobals.ShowErrorMessage($localize`:@@enterValidQuantity:Please enter a valid quantity greater than zero.`);
      return;
    }

    if (this.isEdit) {
      const datasheetEntry = this.projectDatasheets?.find(ds => ds.componentId === this.selectedComponent.componentId);
      this.selectedComponent.docName = datasheetEntry?.dataSheet || null;

      const payload = {
        projectComponentRequestItem: {
          id: this.selectedComponent.id,
          projectId: this.projectId,
          componentId: this.selectedComponent.componentId,
          componentQuantity: this.selectedComponent.quantity,
          DataSheet: this.selectedComponent.docName,
        },
      };
      this.technicalComponentsService.editTechComponentToProject(payload).then(result => {});
      this.closePopup();
      this.reloadDataGrid();
      this.isEdit = false;
      return;
    }
    this.closePopup();

    let selectedComponent = {
      ComponentItem: this.selectedComponent,
    };

    this.technicalComponentsService.editTechComponent(selectedComponent).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          let requestModel = {
            projectComponentRequestItem: {
              id: this.selectedComponent.id,
              projectId: this.projectId,
              componentId: this.selectedComponent.componentId,
              componentQuantity: this.selectedComponent.quantity,
              DataSheet: this.selectedComponent.docName,
            },
          };

          this.technicalComponentsService.editTechComponentToProject(requestModel).then(
            result => {
              if (result.hasError === true) {
                AppGlobals.ShowErrorMessage(result.feedback);
              } else {
                let success = true;
                this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Component Saved` });
                this.reloadDataGrid();
              }
            },
            (error: any) => {
              AppGlobals.ShowErrorMessage(error);
            }
          );
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveNewComponent(e): void {
    e.preventDefault();

    let newComponent = {
      ComponentItem: this.selectedComponent,
    };

    this.technicalComponentsService.addTechComponent(newComponent).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.newestComponentId = result.componentId;
          this.selectedComponent.componentId = result.componentId;

        let componentToAdd = {
          "ProjectId": this.projectId,
          "ComponentId": this.newestComponentId,
          "ComponentQuantity": this.selectedComponent.quantity
        }

        this.technicalComponentsService.addTechComponentToProject({ ProjectComponentRequestItems: [componentToAdd] }).then((result) => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            this.addNewComponentVisible = false;
            this.showQuantityInput = false;
            this.popupVisible = false;
            let success = true;
            this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Component Saved` });

                  // Reload data first, then show upload popup
                  this.reloadDataGrid().then(() => {
                    // Find the newly added component
                    const updatedComponent = this.projectComponentList.find(
                      c => c.componentId === this.newestComponentId
                    );
                    if (updatedComponent) {
                      this.selectedComponent = updatedComponent;
                    }
                  });
                }
              },
              (error: any) => {
                AppGlobals.ShowErrorMessage(error);
              }
            );
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveComponents(e) {
    let payload = new Array();

    this.projectComponentList.forEach(element => {
      payload.push({
        Id: element.id,
        ProjectId: this.projectId,
        ComponentId: element.componentId,
        ComponentQuantity: element.quantity,
      });
    });

    this.technicalComponentsService.saveProjectComponents({ ProjectComponentRequestItems: payload }).then(result => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        let success = true;
        this.saveToast({ type: success, feedback: $localize`:@@componentSaved:Components saved` });
        this.editMode = false;
      }
    });
  }

  amountSelected(): void {
    setTimeout(() => {
      let componentAmountDetails = {
        ProjectId: this.projectId,
        ComponentId: null,
        ComponentQuantity: this.selectedComponent.quantity,
      };

      if (this.newestComponentId != null) {
        componentAmountDetails.ComponentId = this.newestComponentId;
      } else {
        componentAmountDetails.ComponentId = this.selectedComponent.componentId;
      }

      this.technicalComponentsService.editTechComponentToProject(componentAmountDetails).then(
        result => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
            if (this.selectedComponent.hasDataSheet === false) {
              this.amountVisible = false;
              this.uploadDocumentVisible = false;
            }
          } else {
            let success = true;
            this.saveToast({ type: success, feedback: $localize`:@@amountAdded:Amount Added` });
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }, 500);
  }

  addComponent(e): void {
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      return;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.searchTerm = '';
    this.addComponentVisible = true; // Show the popup first
    this.showQuantityInput = false;
    this.calculatePageSize();

    setTimeout(() => {
      if (this.selectedComponentType && this.addComponentGrid?.instance) {
        this.addComponentGrid.instance.filter(['typeId', '=', this.selectedComponentType]);
      } else if (this.addComponentGrid?.instance) {
        this.addComponentGrid.instance.clearFilter();
      }
    }, 200); // 200ms is usually enough, increase if needed
  }

  addComponentToProject(e: any): void {
    this.popupVisible = false;
    this.addComponentVisible = false;
  }

  initDeleteRow(component) {
    this.selectedComponent = component;
    this.deletePopupVisible = true;
  }

  deleteComponent(): void {
    this.deletePopupVisible = false;
    this.closePopup();

    let projectComponent = {
      ProjectId: this.projectId,
      ComponentId: this.selectedComponent.componentId,
    };

    this.technicalComponentsService
      .removeTechComponentFromProject({
        ProjectComponentRequestItems: [{ ProjectId: this.projectId, ComponentId: this.selectedComponent.componentId }],
      })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            var success = true;
            this.saveToast({ type: success, feedback: $localize`:@@componentDeleted:Component Deleted` });
            this.reloadDataGrid();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  reloadDataGrid(): Promise<void> {
    return new Promise((resolve, reject) => {
      let projectId = {
        ProjectId: this.projectId,
      };

      this.technicalComponentsService
        .getProjectTechComponents({
          ProjectComponentRequestItems: [{ ProjectId: this.projectId }],
        })
        .then(
          result => {
            if (result.hasError === true) {
              this.errMsg = result.feedback;
              this.showErrMsg = true;
            } else {
              this.projectComponentList = result.components;
              this.projectNotes = result.globalNotes;
              this.projectDatasheets = result.projectDatasheets;
              this.componentTypeForFilter = this.componentTypes
                .filter(type => this.projectComponentList.some(comp => Number(comp.typeId) === Number(type.id)))
                .sort((a, b) => a.name.localeCompare(b.name));
              resolve();
            }
          },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
            reject(error);
          }
        );
    });
  }

  selectComponent(e: any): void {
    for (let i = 0; i < this.projectComponentList.length; i++) {
      if (e.data.componentId === this.projectComponentList[i].componentId) {
        AppGlobals.ShowErrorMessage(
          $localize`This component already exists in the project components list. Please return and edit the component accordingly.`
        );
        this.closePopup();
        return;
      } else {
        continue;
      }
    }

    if (e.columnIndex === 6) {
      let componentToAdd = {
        ProjectId: this.projectId,
        ComponentId: e.data.componentId,
        ComponentQuantity: e.data.quantity,
      };

      this.technicalComponentsService.addTechComponentToProject(componentToAdd).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            var success = true;
            this.saveToast({ type: success, feedback: $localize`:@@componentAdded:Component Added` });
            this.popUpTitle = $localize`:@@selectAmount:Select Amount`;
            this.addComponentVisible = false;
            this.amountVisible = true;

            this.selectedComponent = e.data;
            this.selectedComponent.componentId = e.data.componentId;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    } else {
      return;
    }
  }

  uploadDocument(e: any): void {
    const file: File = e.value[0];
    if (file) {
      if (file.name.length > AppConfig.MaxFileNameLength) {
        AppGlobals.ShowErrorMessage(
          $localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`
        );
        return;
      }
      const formData = new FormData();
      this.selectedComponentIdForDocUpload = this.selectedComponent.componentId;
      formData.append('FileBytes', e.value[0]);
      formData.append('ComponentId', this.selectedComponentIdForDocUpload);
      formData.append('FileBytesFileName', e.value[0].name);

      this.technicalComponentsService.addTechComponentDataSheet(formData).then(
        result => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            // Update hasDataSheet immediately
            this.selectedComponent.hasDataSheet = true;

            this.closePopup();

            // Reload to get fresh data
            this.reloadDataGrid().then(() => {
              var success = true;
              this.saveToast({ type: success, feedback: $localize`:@@uploadComplete:Upload Complete` });
            });
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  uploadDoc(e: any): void {
    const file: File = e.value[0];
    if (file) {
      const formData = new FormData();
      this.selectedComponentIdForDocUpload = this.selectedComponent.componentId;
      formData.append('FileBytes', e.value[0]);
      formData.append('ComponentId', this.selectedComponentIdForDocUpload);
      formData.append('FileBytesFileName', e.value[0].name);
      formData.append('ProjectComponentId', this.projectId);

      this.technicalComponentsService.addProjectComponentDataSheet(formData).then(result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          // Update hasDataSheet immediately
          this.selectedComponent.hasDataSheet = true;
          this.closePopup();
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@uploadComplete:Upload Complete` });
          this.technicalComponentsService.editTechComponentToProject({
            projectComponentRequestItem: {
              id: this.selectedComponent.id,
              ProjectId: this.projectId,
              ComponentId: this.selectedComponent.componentId,
              ComponentQuantity: this.selectedComponent.quantity,
              DataSheet: result.docName,
            },
          });
        }
        setTimeout(() => {
          this.reloadDataGrid();
        }, 2000);
      });
    }
  }

  noUploadDoc(): void {
    this.reloadDataGrid();
    this.closePopup();
  }

  saveGlobalNotes(e: any): void {
    this.editNotesVisible = false;

    let projectNotes = {
      ProjectId: this.projectId,
      NotesId: null,
      Notes: e,
    };

    this.technicalComponentsService.writeProjectTechComponentNotes(projectNotes).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          var success = true;
          this.saveToast({ type: success, feedback: $localize`:@@noteSaved:Note Saved` });
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  editGlobalNotes(e: any): void {
    this.editNotesVisible = true;
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }

  downloadDataSheet(e: any): void {
    // Find the datasheet name for this componentId
    const datasheetEntry = this.projectDatasheets?.find(ds => ds.componentId === e.data.componentId);
    const datasheetName = datasheetEntry?.dataSheet;
    const originalFileName = datasheetEntry?.fileName;

    if (this.fileViewer != null && datasheetName) {
      this.fileViewer.LoadComponentFileItem(e.data.componentId, datasheetName, originalFileName);
      return;
    }

    // Fallback: If not found, use the old logic or show an error
    AppGlobals.ShowErrorMessage('No datasheet found for this component.');
  }

  changeManufacturer(e: any): void {
    for (let i = 0; i < this.companyList.length; i++) {
      if (e.selectedItem.id === this.companyList[i].id) {
        this.selectedComponent.manufacturerName === this.companyList[i].name;
        this.selectedComponent.manufacturerId === this.companyList[i].id;
      }
    }
  }

  removeDocument(componentId: any): void {
    let techComponent = {
      ComponentItem: {
        ComponentId: componentId,
      },
    };

    this.technicalComponentsService.removeTechComponentDataSheet(techComponent).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          let success = true;
          this.saveToast({ type: success, feedback: $localize`:@@documentRemoved:Document removed` });
          this.closePopup();
          setTimeout(() => {
            this.reloadDataGrid();
          }, 200);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  doSearch(e: any): void {
    this.contentLoadedVisible = false;
    this.searchTerm = e.value;
    if (this.searchTerm.length < 2) {
      if (this.dataGridSearch) {
        this.dataGridSearch.instance.searchByText('');
        this.appGlobals.setSearchPanelText('');
        this.contentLoadedVisible = true;
      }
      return;
    }
    if (this.dataGridSearch) {
      this.dataGridSearch.instance.searchByText(this.searchTerm);
      this.appGlobals.setSearchPanelText(this.searchTerm);
      this.contentLoadedVisible = true;
    }
  }

  hideAll(): void {
    this.popupVisible = false;
    this.toastVisible = false;
    this.addComponentGridSelection = null;
  }

  isEdit: boolean = false;
  private editActionTriggered: boolean = false;
  editRow(e, row) {
    if (this.projectStatus === ProjectStatus.COMPLETED) {
      this.globalPopupService.showWarningPopup(this.completedProjectWarning);
      if (e && e.stopPropagation) e.stopPropagation();
      return;
    }
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      if (e && e.stopPropagation) e.stopPropagation();
      return;
    }
    // Set flag to indicate edit action
    this.editActionTriggered = true;
    this.editComponentVisible = true;
    this.selectedComponent = row;
    this.isEdit = true;
    this.detailsPanelVisible = false;
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
  }

  onInitNewRow(e) {
    if (e.data.id == null || e.data.id == undefined) {
      e.data.id = this.getNewId();
    }
  }

  onSaved(e) {}

  onAddComponentGridSelectionChanged(e) {
    this.addComponentGridSelection = e.currentSelectedRowKeys[0];
  }

  checkIfLessThanZero(item) {
    return item.value > 0 ? true : false;
  }

  formatterGerman(e: any) {
    if (e != undefined) {
      return new Intl.NumberFormat('de-DE').format(e);
    }
  }

  changeComponentType(e: any): void {
    this.selectedComponent.typeId = e.selectedItem.id;
    this.selectedComponent.type = e.selectedItem.name;
  }

  getDatasheetName(componentId: number): string | null {
    const entry = this.projectDatasheets?.find(ds => ds.componentId === componentId);
    return entry?.dataSheet || null;
  }

  downloadTechDoc(docName: string): void {
    this.technicalComponentsService.downloadTechComponentDocumentByFileName({ FileName: docName }).then(result => {
      this.downloadFileFromBytes(result.fileName, result.fileBytes, result.contentType);
    });
  }

  downloadFileFromBytes(fileName: string, base64Bytes: string, contentType: string): void {
    // Convert base64 to Uint8Array
    const binaryString = window.atob(base64Bytes);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // Create Blob
    const blob = new Blob([bytes], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    // Trigger download with the correct file name
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.open(url, '_blank');
  }
  showErrMsg: boolean = false;
  errMsg: string = '';
  goToComponentLibrary(): void {
    if (this.selectedComponentToAdd) {
      this.router.navigate(['/tech-components'], {
        queryParams: { componentId: this.selectedComponentToAdd.componentId },
      });
    } else {
      this.router.navigate(['/tech-components']);
    }
  }

  closeErrMsg(): void {
    this.showErrMsg = false;
    this.errMsg = '';
    this.reloadDataGrid();
  }

  componentTypeForFilter: any = {};

  filterBySelectedComponentType(): void {
    if (this.selectedComponentType) {
      // Apply filter to the DataGrid by typeId
      this.componentGrid.instance.filter(['typeId', '=', this.selectedComponentType]);
    } else {
      // Clear filter if no type is selected
      this.componentGrid.instance.clearFilter();
    }
  }
  onSearchValueChanged(e: any) {
    this.componentGrid.instance.searchByText(e.value);
  }

  showAllComponents(): void {
    this.selectedComponentType = null;
    if (this.componentGrid?.instance) {
      this.componentGrid.instance.clearFilter();
    }
  }

  exportComponentData(): void {
    if (!this.componentGrid?.instance) {
      return;
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Project Components');

    exportDataGrid({
      component: this.componentGrid.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ProjectComponents.xlsx');
        this.loggingService.logFileExport(buffer, 'ProjectComponents.xlsx', {
          section: ActivitySection.PROJECT_COMPONENTS,
          projectId: this.projectId ? Number(this.projectId) : null,
        });
      });
    });

    // Show success message
    this.saveToast({
      type: true,
      feedback: $localize`:@@exportComplete:Export Complete`,
    });
  }

  itemsPerPage: number = 0;
  currentPage: number = 0;
  totalPages: number = 0;
  totalItems: number = 0;
  get showingFrom(): number {
    if (this.totalItems === 0) return 0;
    return this.itemsPerPage * (this.currentPage - 1) + 1;
  }

  get showingTo(): number {
    return Math.min(this.itemsPerPage * this.currentPage, this.totalItems);
  }

  goToNextPage(): void {
    if (this.componentGrid?.instance) {
      const currentIndex = this.componentGrid.instance.pageIndex();
      const totalPages = this.componentGrid.instance.pageCount();
      if (currentIndex < totalPages - 1) {
        this.componentGrid.instance.pageIndex(currentIndex + 1);
        this.getGridPageInfo();
      }
    }
  }

  goToPreviousPage(): void {
    if (this.componentGrid?.instance) {
      const currentIndex = this.componentGrid.instance.pageIndex();
      if (currentIndex > 0) {
        this.componentGrid.instance.pageIndex(currentIndex - 1);
        this.getGridPageInfo();
      }
    }
  }

  getGridPageInfo(): void {
    if (!this.componentGrid?.instance) {
      return;
    }
    this.currentPage = this.componentGrid.instance.pageIndex() + 1; // 1-based for display
    this.totalPages = this.componentGrid.instance.pageCount();
    this.itemsPerPage = this.componentGrid.instance.pageSize();
    this.totalItems = this.componentGrid.instance.totalCount();
  }

  onGridOptionChanged(e: any): void {
    if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize' || e.fullName === 'dataSource') {
      this.getGridPageInfo();
    }
  }

  calculatePageSize(): void {
    const viewportHeight = window.innerHeight;

    const headerHeight = 180; // Header + search + margins
    const footerHeight = 150; // Form + buttons + margins
    const availableHeight = viewportHeight - headerHeight - footerHeight;

    const gridHeaderHeight = 40;
    const pagerHeight = 40;
    const rowHeight = 50;

    const availableRowHeight = availableHeight - gridHeaderHeight - pagerHeight;

    // Calculate how many rows can fit
    const calculatedPageSize = Math.floor(availableRowHeight / rowHeight);

    // Set minimum and maximum page sizes
    const minPageSize = 5;
    const maxPageSize = 10;

    this.addComponentGridPageSize = Math.max(minPageSize, Math.min(calculatedPageSize, maxPageSize));

    // Update the grid if it exists
    if (this.addComponentGrid?.instance) {
      this.addComponentGrid.instance.pageSize(this.addComponentGridPageSize);
      this.addComponentGrid.instance.repaint();
    }
  }

  closeAddComponent(): void {
    this.addComponentVisible = false;
    this.addComponentSearchTerm = '';
  }

  // Add Component Grid Pagination
  addComponentCurrentPage: number = 1;
  addComponentTotalPages: number = 1;
  addComponentItemsPerPage: number = 0;
  addComponentTotalItems: number = 0;

  get addComponentShowingFrom(): number {
    if (this.addComponentTotalItems === 0) return 0;
    return this.addComponentItemsPerPage * (this.addComponentCurrentPage - 1) + 1;
  }

  get addComponentShowingTo(): number {
    return Math.min(this.addComponentItemsPerPage * this.addComponentCurrentPage, this.addComponentTotalItems);
  }

  getAddComponentGridPageInfo(): void {
    if (!this.addComponentGrid?.instance) {
      return;
    }
    this.addComponentCurrentPage = this.addComponentGrid.instance.pageIndex() + 1;
    this.addComponentTotalPages = this.addComponentGrid.instance.pageCount();
    this.addComponentItemsPerPage = this.addComponentGrid.instance.pageSize();
    this.addComponentTotalItems = this.addComponentGrid.instance.totalCount();
  }

  onAddComponentGridOptionChanged(e: any): void {
    if (e.fullName === 'paging.pageIndex' || e.fullName === 'paging.pageSize' || e.fullName === 'dataSource') {
      this.getAddComponentGridPageInfo();
    }
  }

  onAddComponentPageChange(page: number): void {
    if (this.addComponentGrid?.instance) {
      this.addComponentGrid.instance.pageIndex(page - 1);
      this.getAddComponentGridPageInfo();
    }
  }

  onPageChange(page: number): void {
    if (this.componentGrid?.instance) {
      this.componentGrid.instance.pageIndex(page - 1);
      this.getGridPageInfo();
    }
  }

  get totalItemsForSelectedType(): number {
    if (this.dataGridSearch?.instance) {
      return this.dataGridSearch.instance.totalCount();
    }
    return this.projectComponentList.length;
  }

  // Details Panel Methods
  private rowClickTimer: any = null;

  onRowClick(e: any): void {
    if (e.column && e.column.cellTemplate === 'buttonCellTemplate') {
      this.editActionTriggered = true;
      return;
    }
    if (this.editActionTriggered) {
      this.editActionTriggered = false;
      return;
    }

    if (this.rowClickTimer) {
      clearTimeout(this.rowClickTimer);
      this.rowClickTimer = null;
      this.editActionTriggered = false;
      this.editRow(null, e.data);
      return;
    }

    this.rowClickTimer = setTimeout(() => {
      this.rowClickTimer = null;
      this.showDetailsPanel(e.data);
    }, 250);
  }


  onAddComponentRowPrepared(e: any): void {
    if (e.rowType === 'data' && e.data && !e.data.isCompleted) {
      e.rowElement.classList.add('component-incomplete');
    }
  }

  onComponentRowClick(e: any): void {
    if (!e.data.isCompleted) {
      this.showQuantityInput = false;
      this.addComponentGridSelection = null;
      if (this.addComponentGrid?.instance) {
        this.addComponentGrid.instance.deselectAll();
      }
      return;
    }
    this.showQuantityInput = true;
    this.selectedComponent = e.data;
  }

  getComponentDocsList(): void {
    this.technicalComponentsService.getComponentTypeDocs({}).then(result => {
      this.documentList = result.documents;
    });
  }

  getAllDocLinks(): void {
    this.technicalComponentsService.getAllDocumentLink({}).then(result => {
      this.doclinks = result.componentDocData;
    });
  }

  showDetailsPanel(data: any): void {
    this.componentId = data.componentId;
    this.detailsPanelVisible = true;
    this.getComponentDetailsForPanel(data);
    this.getDocsForThisComponent();
    this.detailsPanelHeight = this.availableHeight;
  }

  closeDetailsPanel(): void {
    this.detailsPanelVisible = false;
  }

  getComponentDetailsForPanel(data: any): void {
    const typeName = this.componentTypes?.find(t => t.id === data.typeId)?.name || '';

    // Set initial details immediately (fixed fields only)
    this.componentDetails = [
      {
        model: data.model,
        manufacturerName: data.manufacturerName,
        type: typeName,
        status: data.status || 'Active',
        dataFields: [{ fieldName: $localize`:@@quantityAnzhal:Quantity`, value: data.quantity?.toString() || '0' }],
      },
    ];

    // Fetch dynamic data fields from the API and append them
    this.technicalComponentsService.getComponentWithDataFields({ ComponentId: data.componentId }).then(result => {
      if (!result.hasError && result.componentDetails?.length > 0) {
        const apiFields: { fieldName: string; value: string }[] = (result.componentDetails[0].dataFields ?? []).map(
          (f: any) => ({ fieldName: f.fieldName, value: f.value ?? '' })
        );
        if (apiFields.length > 0) {
          this.componentDetails = [
            {
              ...this.componentDetails[0],
              dataFields: [
                { fieldName: $localize`:@@quantityAnzhal:Quantity`, value: data.quantity?.toString() || '0' },
                ...apiFields,
              ],
            },
          ];
        }
      }
    });
  }

  getDocsForThisComponent(): void {
    const payload = {
      TechComponentId: this.componentId,
    };

    this.technicalComponentsService.getTechComponentDocs(payload, false).then(result => {
      this.downloadLinks = result.componentDocData;
      this.disableDownloadAll = this.filteredDownloadLinks.length === 0;
    });
  }

  get filteredDownloadLinks(): any[] {
    if (!this.downloadLinks || !this.componentId) return [];
    return this.downloadLinks.filter(dl => dl.docLink && dl.componentId === this.componentId);
  }

  onEditFromPanel(): void {
    const component = this.projectComponentList.find(c => c.componentId === this.componentId);
    if (component) {
      this.detailsPanelVisible = false;
      this.editRow(null, component);
    }
  }
  downloadAllDocs(): void {
    const componentId = this.componentId;
    this.technicalComponentsService.downloadAllComponentDocuments({ componentId }).then(result => {
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.apiFileService.downloadTempFile(result.downloadId, result.downloadFileName);
    });
  }
}

